
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiError as ObiErrorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-error.js';
 
 
 

 
 export const ObiError = createComponent({
   react: React,
   tagName: 'obi-error',
   elementClass: ObiErrorElement,
   events: {
     
   }
  });
 
 